import useAuthentication from "@/hooks/useAuthentication";
import usePathWithSlug from "@/hooks/usePathWithSlug";
import { PageSpinner } from "@/ui/Spinner";
import { Navigate, useSearchParams } from "react-router-dom";

export const withAuth = <P extends object>(Component: React.ComponentType<P>) => {
  return (props: P) => {
    const { user } = useAuthentication();
    const [searchParams] = useSearchParams();
    const thriveToken = searchParams.get("thrive_token");
    const pathWithSlug = usePathWithSlug();

    if (thriveToken) {
      return <PageSpinner />;
    }

    if (!user) {
      return <Navigate to={pathWithSlug("/")} />;
    }

    return <Component {...props} />;
  };
};
